import React from 'react';
import { Helmet } from 'react-helmet-async';
import { canonicalBaseUrl, siteName } from '../seo/siteConfig';

const graph = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'AutoRepair',
      '@id': `${canonicalBaseUrl}/#business`,
      name: siteName,
      description:
        'Diesel fuel injection specialists in Johannesburg: pump and injector repair, engine overhauls, diagnostics, and turbo service. RMI member, established 1969.',
      url: canonicalBaseUrl,
      telephone: ['+27114936226', '+27812467394'],
      email: 'dieselct2@mweb.co.za',
      priceRange: '$$',
      address: {
        '@type': 'PostalAddress',
        streetAddress: '46 John Street, Selby',
        addressLocality: 'Johannesburg',
        postalCode: '2001',
        addressCountry: 'ZA',
      },
      openingHoursSpecification: [
        {
          '@type': 'OpeningHoursSpecification',
          dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday'],
          opens: '07:00',
          closes: '16:30',
        },
        {
          '@type': 'OpeningHoursSpecification',
          dayOfWeek: 'Friday',
          opens: '07:00',
          closes: '15:30',
        },
      ],
    },
    {
      '@type': 'WebSite',
      '@id': `${canonicalBaseUrl}/#website`,
      url: canonicalBaseUrl,
      name: siteName,
      publisher: { '@id': `${canonicalBaseUrl}/#business` },
      inLanguage: 'en-ZA',
    },
  ],
};

export default function SiteJsonLd() {
  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(graph)}</script>
    </Helmet>
  );
}
